import { przezmorzeApi } from "../../../../api/api";

export async function getProductsCsv(abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeApi.get<Blob>(`/product-export/csv`, {
    signal: abortSignal,
    headers: { Accept: "application/csv" },
    responseType: "blob",
  });
  return response.data;
}

export async function getProductsOptionsCsv(abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeApi.get<Blob>(`/product-export/options/csv`, {
    signal: abortSignal,
    headers: { Accept: "application/csv" },
    responseType: "blob",
  });
  return response.data;
}
